import { useEffect } from "react";

export const useOutsideClick = (ref, onClickOutside, toExclude?: string[]) => {
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        typeof e.target?.className === "string" &&
        toExclude?.some((className) => e.target?.className?.includes(className))
      )
        return;
      if (ref.current && !ref.current.contains(e.target)) onClickOutside();
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClickOutside, ref, toExclude]);
};
